
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const contactJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: 'Contact VORENN TECH',
    description: 'Get in touch with VORENN TECH for IT consulting, cloud migration, cybersecurity, and managed IT support inquiries.',
    url: `${SITE_URL}/contact`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'Contact', item: `${SITE_URL}/contact` },
      ],
    },
  },
];

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Contact Us - Get IT Support & Consultation | VORENN TECH"
        description="Contact VORENN TECH for expert IT consulting, cloud migration, cybersecurity, and managed IT support. Reach our team for a free consultation today."
        keywords="contact VORENN TECH, IT support contact, IT consultation request, cybersecurity help"
        canonical="/contact"
        jsonLd={contactJsonLd}
      />
      <Navbar />
      <ContactHero />
      <div className="py-24 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <ContactForm />
            <ContactInfo />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;